import { render, staticRenderFns } from "./SingleCandidate.vue?vue&type=template&id=5d3b7812&scoped=true"
import script from "./SingleCandidate.vue?vue&type=script&lang=ts"
export * from "./SingleCandidate.vue?vue&type=script&lang=ts"
import style0 from "./SingleCandidate.vue?vue&type=style&index=0&id=5d3b7812&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3b7812",
  null
  
)

export default component.exports